import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { EventOutlined } from '@mui/icons-material'
import { ButtonLink } from '../../../../components/wrappers/Button'
import { TtoggleDrawerOnMobile } from '../../../../containers/Sidebar/Sidebar'
import { useIntl } from 'react-intl'

interface MenuEventsProps {
  pathname: string
  nested?: string
  toggleDrawerOnMobile: TtoggleDrawerOnMobile
}

export const MenuEvents = ({
  pathname,
  nested,
  toggleDrawerOnMobile,
}: MenuEventsProps) => {
  const { formatMessage } = useIntl()
  return (
    <div onClick={toggleDrawerOnMobile}>
      <MenuItem
        className={nested}
        component={ButtonLink}
        href="/live-chat/events"
        selected={pathname.startsWith('/live-chat/events')}
      >
        <ListItemIcon>
          <EventOutlined />
        </ListItemIcon>
        <ListItemText
          primary={formatMessage({
            id: 'liveChat.sidebar.events',
          })}
        />
      </MenuItem>
    </div>
  )
}
